import { ConsumptionRedirectComponent } from './components/workflow-new/consumption-redirect/consumption-redirect.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { NavbarComponent } from './components/partials/navbar/navbar.component';
import { FooterComponent } from './components/partials/footer/footer.component';

import { CoursesComponent } from './components/course/courses.component';
import { DeliverablesComponent } from './components/deliverable/deliverables.component';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { RegisterComponent } from './components/register/register.component';
import { RegisterWtihVoucherComponent } from './components/register-with-voucher/register-voucher.component';
import { RedeemVoucherComponent } from './components/redeem/redeem.component';
import { SupportComponent } from './components/support/support.component';
import { ProfileComponent } from './components/profile/profile.component';
import { AuthGuard } from './guards/auth.guard';
import { LoginGuard } from './guards/login.guard';
import { DomainGuard } from './guards/domain.guard';
import { ScormComponent } from './components/content/scorm/scorm.component';
import { DummyComponent } from './components/content/scorm/dummy/dummy.component';
import { EBookComponent } from './components/content/ebook/ebook.component';
import { ArchiveComponent } from './components/content/archive/archive.component';
import { ISpringComponent } from './components/content/ispring/ispring.component';
import { ClassPreviewComponent } from './components/class/class-preview.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { ScormCloudComponent } from './components/content/scormcloud/scorm-cloud.component';
import { EvaluationDeliverablesComponent } from './components/evaluation/deliverable/deliverables.component';
import { EvaluationNavbarComponent } from './components/evaluation/navbar/navbar.component';
import { EvaluationScormComponent } from './components/evaluation/content/scorm/scorm.component';
import { EvaluationScormCloudComponent } from './components/evaluation/content/scormcloud/scorm-cloud.component';
import { EvaluationEBookComponent } from './components/evaluation/content/ebook/ebook.component';
import { EvaluationISpringComponent } from './components/evaluation/content/ispring/ispring.component';
import { EvaluationArchiveComponent } from './components/evaluation/content/archive/archive.component';
import { GoogleSlidesComponent } from './components/content/google-slides/google-slides.component';
import { VideoComponent } from './components/content/video/video.component';
import { ScormCloudPlayerComponent } from 'app/core/components/scorm-cloud-player/scorm-cloud-player.component';
import { RegisterVoucherNewComponent } from './components/register-voucher-new/register-voucher-new.component';
import { RedeemNewComponent } from 'app/core/components/redeem-new/redeem-new.component';
import { RegisterUserComponent } from 'app/core/components/register-user/register-user.component';
import { CourseStackPresentationComponent } from 'app/core/components/workflow-new/course/course-stack-presentation/course-stack-presentation.component';
import { MaterialStackContainerComponent } from 'app/core/components/workflow-new/material/material-stack-container/material-stack-container.component';
import { CourseContainerComponent } from 'app/core/components/workflow-new/course/course-container/course-container.component';
import { PageNotFoundComponent } from 'app/core/components/workflow-new/page-not-found/page-not-found.component';
import { EvaluationMaterialsComponent } from 'app/core/components/evaluation/workflow_new/evaluation-materials/evaluation-materials.component';
import { EvaluationVideoComponent } from 'app/core/components/evaluation/content/video/video.component';
import { EvaluationGoogleSlidesComponent } from 'app/core/components/evaluation/content/google-slides/google-slides.component';
import { SelfRegisterGuard } from 'app/core/guards/self-register.guard';
import { SelfRegisterComponent } from 'app/core/components/self-register/self-register.component';
import {LxpProductLandingComponent} from './components/workflow-new/material/lxp-product-landing/lxp-product-landing.component';
import { LxpCourseLandingComponent } from './components/lxp-course-landing/lxp-course-landing.component';
import { EventListingComponent } from './components/workflow-new/event-listing/event-listing.component';
import { SelfRegisterValidateComponent } from './components/self-register/self-register-validate.component';

@NgModule({
  imports: [RouterModule.forChild([
    {
      path: '', children: [
        { path: 'welcome', canActivate: [DomainGuard, LoginGuard], component: WelcomeComponent },
        { path: 'register/:key', canActivate: [DomainGuard, LoginGuard], component: RegisterUserComponent },
        { path: 'self-register', canActivate: [DomainGuard, LoginGuard, SelfRegisterGuard], component: SelfRegisterValidateComponent },
        { path: 'register-with-voucher', canActivate: [DomainGuard, LoginGuard], component: RegisterVoucherNewComponent },
        { path: 'support', canActivate: [DomainGuard], component: SupportComponent },
        { path: 'privacy', canActivate: [DomainGuard, LoginGuard], component: PrivacyPolicyComponent },
        { path: 'account', canActivate: [DomainGuard, AuthGuard], component: ProfileComponent },
        { path: '', redirectTo: '/app', pathMatch: 'full' },
        { path: '', component: NavbarComponent, outlet: 'navbar' },
        // { path: '', component: FooterComponent, outlet: 'footer' }
      ]
    },
    {
      path: 'app', data: { breadcrumb: 'Home' }, children: [
        { path: '', canActivate: [DomainGuard, AuthGuard], component: CourseStackPresentationComponent },
        { path: 'redeem', canActivate: [DomainGuard, AuthGuard], component: RedeemNewComponent },
        {
          path: 'class/:id', data: { breadcrumb: 'Class' }, children: [
            {path: '', canActivate: [DomainGuard, AuthGuard], component: CourseContainerComponent},
            { path: 'course/:assignmentId', canActivate: [DomainGuard, AuthGuard], data: { breadcrumb: 'Material' },
            children: [
              { path: '', component: MaterialStackContainerComponent},
              { path: 'scormcloud/:registrationId/:deliverableId', canActivate: [DomainGuard, AuthGuard], component: ScormCloudComponent, data: {breadcrumb: 'SCORM Player'}},
              { path: 'scorm/:deliverableId', canActivate: [DomainGuard, AuthGuard], component: ScormComponent, data: {breadcrumb: 'SCORM Player'}},
              { path: 'video/:deliverableId', canActivate: [DomainGuard, AuthGuard], component: VideoComponent, data: {breadcrumb: 'Video Player'}},
              { path: 'googleslides/:deliverableId', canActivate: [DomainGuard, AuthGuard], component: GoogleSlidesComponent, data: {breadcrumb: 'Presentation Viewer'}}
            ] }
          ]
        },
        { path: 'exam/:id', canActivate: [DomainGuard, AuthGuard], component: CourseContainerComponent, data: { breadcrumb: 'Exam Session' } },
        { path: 'courses', canActivate: [DomainGuard, AuthGuard], component: CoursesComponent },
        {
          path: 'course/:assignmentId', data: { breadcrumb: 'Material' },
          children: [
            { path: '', canActivate: [DomainGuard, AuthGuard], component: MaterialStackContainerComponent},
            { path: 'scormcloud/:registrationId/:deliverableId', canActivate: [DomainGuard, AuthGuard], component: ScormCloudComponent, data: {breadcrumb: 'SCORM Player'}},
            { path: 'scorm/:deliverableId', canActivate: [DomainGuard, AuthGuard], component: ScormComponent, data: {breadcrumb: 'SCORM Player'}},
            { path: 'video/:deliverableId', canActivate: [DomainGuard, AuthGuard], component: VideoComponent, data: {breadcrumb: 'Video Player'}},
            { path: 'googleslides/:deliverableId', canActivate: [DomainGuard, AuthGuard], component: GoogleSlidesComponent, data: {breadcrumb: 'Presentation Viewer'}}
          ]
        },
        { path: 'dummy', component: DummyComponent },
        { path: '', component: NavbarComponent, outlet: 'navbar' },
        { path: 'product/:sku', component: LxpProductLandingComponent, canActivate: [DomainGuard, AuthGuard] },
        { path: 'consume/:sku', component: ConsumptionRedirectComponent, canActivate: [DomainGuard, AuthGuard]},
        { path: 'course-details/:course-id', component: LxpCourseLandingComponent, canActivate: [DomainGuard, AuthGuard]},
        { path: 'events/:id', component: EventListingComponent, canActivate: [DomainGuard, AuthGuard]}
      ]
    }, {
      path: 'evaluation', children: [
        { path: 'course/:assignmentId', component: EvaluationMaterialsComponent },
        { path: 'scorm/:assignmentId/:deliverableId', component: EvaluationScormComponent },
        { path: 'scormcloud/:deliverableId', component: EvaluationScormCloudComponent },
        { path: 'dummy', component: DummyComponent },
        { path: 'ebook/:assignmentId/:deliverableId', component:EvaluationEBookComponent },
        { path: 'archive/:assignmentId/:deliverableId', component: EvaluationArchiveComponent },
        { path: 'ispring/:assignmentId/:deliverableId', component: EvaluationISpringComponent },
        { path: 'video/:assignmentId/:deliverableId', component: EvaluationVideoComponent },
        { path: 'googleslides/:assignmentId/:deliverableId', component: EvaluationGoogleSlidesComponent },
        { path: '', component: EvaluationNavbarComponent, outlet: 'navbar' },
        { path: '', component: FooterComponent, outlet: 'footer' }
      ]
    },
    { path: '**', component: PageNotFoundComponent }
  ])],
  exports: [RouterModule]
})

export class CoreRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/core/core-routing.module.ts